import React, { Dispatch, SetStateAction, useEffect, useState } from "react";
import { Grid, Menu, MenuProps, Typography } from "antd";
import { Link, useLocation } from "react-router-dom";
import Icon from "../icon/icon";
import "./menu.scss";
import { adminMenuData, userMenuData } from "../../config/menu";
import { useSelector } from "react-redux";
import { RootState } from "../../redux/store";
import { GetPermissionRes } from "../../interfaces/role.interface";

type MenuItem = Required<MenuProps>["items"][number];

const { useBreakpoint } = Grid;

const BASE_PATH = "/panel";
const ADMIN_BASE_PATH = "/panel/admin";

interface Props {
  setIsCollapsed: Dispatch<SetStateAction<boolean>>;
}

export const UserMenu = (props: Props) => {
  const screens = useBreakpoint();

  const userPermissions = useSelector<RootState, GetPermissionRes[]>(
    (root) => root.user.permissions
  );

  const location = useLocation();
  const currentPath = location.pathname;

  const userMenuItems: MenuItem[] = [];

  userMenuData.map((item) => {
    const hasPermission = userPermissions.some((item1) =>
      item.permissions.some((item2) => item1.code === item2)
    );

    if (hasPermission) {
      userMenuItems.push({
        key: `${BASE_PATH}/${item.key}`,
        label: <Link to={`${BASE_PATH}/${item.key}`}>{item.label}</Link>,
        icon: <Icon src={item.icon} />,
      });
    }
  });

  return (
    <Menu
      items={userMenuItems}
      selectedKeys={[currentPath]}
      mode="inline"
      onSelect={(e) => {
        setTimeout(() => {
          if (screens.xs) {
            props.setIsCollapsed(true);
          }
        }, 50);
      }}
    />
  );
};

export const AdminMenu = (props: Props) => {
  const screens = useBreakpoint();

  const location = useLocation();
  const currentPath = location.pathname;
  const userPermissions = useSelector<RootState, GetPermissionRes[]>(
    (root) => root.user.permissions
  );

  const adminMenuItems: MenuItem[] = [];

  adminMenuData.map((item) => {
    const hasPermission = userPermissions.some((p1) =>
      item.permissions.some((p2) => p1.code === p2)
    );

    if (hasPermission) {
      const children: any[] = [];

      item.Children?.map((item2) => {
        const hasPermission = userPermissions.some((p1) =>
          item2.permissions.some((p2) => p1.code === p2)
        );

        if (hasPermission) {
          children.push({
            key: `${ADMIN_BASE_PATH}/${item2.key}`,
            label: (
              <Link to={`${ADMIN_BASE_PATH}/${item2.key}`}>{item2.label}</Link>
            ),
            icon: <Icon src={item2.icon} />,
          });
        }
      });

      adminMenuItems.push({
        key: `${ADMIN_BASE_PATH}/${item.key}`,
        label:
          children.length === 0 ? (
            <Link to={`${ADMIN_BASE_PATH}/${item.key}`}>{item.label}</Link>
          ) : (
            <Typography.Text>{item.label}</Typography.Text>
          ),
        icon: <Icon src={item.icon} />,
        children: children.length === 0 ? undefined : children,
      });
    }
  });

  // ********************************************************************
  const [stateOpenKeys, setStateOpenKeys] = useState<string[]>([]);

  useEffect(() => {
    const openKeys = [...stateOpenKeys];

    if (currentPath.indexOf("org") != -1) {
      openKeys.push("/panel/admin/organization");
    }
    if (currentPath.indexOf("alert") != -1) {
      openKeys.push("/panel/admin/alert");
    }

    setStateOpenKeys(openKeys);
  }, []);
  interface LevelKeysProps {
    key?: string;
    children?: LevelKeysProps[];
  }
  const getLevelKeys = (items1: LevelKeysProps[]) => {
    const key: Record<string, number> = {};
    const func = (items2: LevelKeysProps[], level = 1) => {
      items2.forEach((item) => {
        if (item.key) {
          key[item.key] = level;
        }
        if (item.children) {
          func(item.children, level + 1);
        }
      });
    };
    func(items1);
    return key;
  };
  const levelKeys = getLevelKeys(adminMenuItems as LevelKeysProps[]);
  const onOpenChange: MenuProps["onOpenChange"] = (openKeys) => {
    const currentOpenKey = openKeys.find(
      (key) => stateOpenKeys.indexOf(key) === -1
    );
    // open
    if (currentOpenKey !== undefined) {
      const repeatIndex = openKeys
        .filter((key) => key !== currentOpenKey)
        .findIndex((key) => levelKeys[key] === levelKeys[currentOpenKey]);

      setStateOpenKeys(
        openKeys
          // remove repeat key
          .filter((_, index) => index !== repeatIndex)
          // remove current level all child
          .filter((key) => levelKeys[key] <= levelKeys[currentOpenKey])
      );
    } else {
      // close
      setStateOpenKeys(openKeys);
    }
  };
  // ********************************************************************

  return (
    <Menu
      items={adminMenuItems}
      selectedKeys={[currentPath]}
      //openKeys={openKeys}
      openKeys={stateOpenKeys}
      onOpenChange={onOpenChange}
      mode="inline"
      onSelect={(e) => {
        setTimeout(() => {
          if (screens.xs) {
            props.setIsCollapsed(true);
          }
        }, 50);
      }}
    />
  );
};
